import {computed, ref, watch} from "vue";
import {useStore} from "vuex";
import {useRoute, useRouter} from "vue-router";

export default function() {
  const detailItem = ref(null)
  const selectedItem = ref(null);
  const store = useStore();
  const route = useRoute()
  const router = useRouter()
  const currentRoute = ref(route.name.toLowerCase())

  const currentStepData = computed(() => {
    if (currentRoute.value){
      return store.getters.getSteps(currentRoute.value)
    } else {
      console.log("step param is undefined")
      return ""
    }
  })

  const results = computed(() => {
    return store.state.moduleA.results;
  })

  /* add selected item as a state */
  function selected(){
    const selected = results.value.find(result => {
      return "step"+result.step === currentRoute.value;
    })
    selectedItem.value = selected ? selected : null
  }

  selected()

  /* insert selected item into store && replace with new query */
  function selection(value){
      
    const arr = [selectedItem.value]
    const filtered = results.value.filter(result => {
      return result.property !== selectedItem.value.property
    }).concat(arr)

    store.commit("setResults", filtered)
    let queryObj = {gender:route.query.gender}


    if(!['taiyoboriBase','hoshiboriBase'].includes(value)){

      results.value.forEach(item => {
        if (item.hasOwnProperty("option") && item.option){
          const newVal = item.val.split("_")[0]
          item.val = newVal+"_"+item.option
        }
        Object.assign(queryObj, {[item.property]:item.val})
      })
    }else{//tayori hoshibori no bai

      results.value.forEach(item => {
        Object.assign(queryObj, {[item.property]:item.val})
      })
    }
    
    router.replace({query:queryObj}).then(() => {
      store.commit("setDialog", false);
    })
     
  }

  /* store selected item, ready to store/before store */
  const storeItem = (data, option=null) => {
    let parsed
    if(currentRoute.value === "step7") {
      parsed = JSON.parse(JSON.stringify(data))
    }else {
      parsed = data
    }

    if (option){
      parsed.option = option
      if(currentRoute.value === "step7") {
        //If tab 2,3,horibori (no stone) or taiyoubori (no stone), delete option 
        if (parsed.val === 'taiyoboriBase'||parsed.val === 'hoshiboriBase'){   
          parsed.option = null
        }
        if (parsed.tab > 1){
          parsed.option = null        
        }
      }
    }
    //if a ring from tab 1 was selected WITHOUT choosing a color, set the color to null (transparent)
    else{
      parsed.option = null
    }
    selectedItem.value = parsed
  }

  /* store insertion func. */
  const selectItem = (value = null) => {
    selection(value)
  }

  const removeItem = (data=null) => {
    if(data){
      const filtered = results.value.filter(result => {
        if(selectedItem.value)
          return result.property !== selectedItem.value.property
        return true
      })

      store.commit("setResults", filtered)
      let queryObj = {gender:route.query.gender}
      results.value.forEach(item => {
        if (item.hasOwnProperty("option") && item.option){
          const newVal = item.val.split("_")[0]
          item.val = newVal+"_"+item.option
        }
        Object.assign(queryObj, {[item.property]:item.val})
      })
      router.replace({query:queryObj}).then(() => {
        store.commit("setDialog", false);
      })
    }
    selectedItem.value = null
  }

  const toggleDialog = (param) => {
    store.commit("setDialog", param);
  }

  const toggleSubDialog = (data, visible) => {
    const payload = {visible:visible, data:data}
    store.commit("setSubDialog", payload);
  }

  return {
    store, currentRoute, currentStepData, results,
    toggleDialog, toggleSubDialog, storeItem, selectItem, removeItem,
    selectedItem, detailItem}

}
